<div class="login-page-container">
    <img class="twint-logo" src="assets/twint.svg" />
    <div class="login-content">
        <div class="login-msg-img">
            <img class="login-logo" src="assets/clock.svg" />
            <span class="login-msg">{{ 'tsd_shop_default_navigation_time_out_msg' | localize | async }}</span>
        </div>
    </div>
</div>
